import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import { useForm } from 'react-hook-form';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { signInUser } from '#action/user/settings';
import { reduxFormResolver } from '#helper/rhf-resolver';
import RHFTextField from '#component/form/rhf/rhf-text-field';
import { whitelabel } from '#config/whitelabel';
import {
  ButtonsContainer,
  CompanyImgCnt,
  CompanyImgLogo,
  DivPaper,
  ForgotBtn,
  MainBg,
  StyledForm,
  StyledH5,
  StyledMain
} from '#component/user/auth-challenge/styles';
import validate from './validate';
import propTypes from './prop-types';
import { setDocumentTitle } from '#helper';

const SignInForm = props => {
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setDocumentTitle('Sign in');
  }, []);

  const { control, handleSubmit, formState: { isSubmitting } } = useForm({
    resolver: reduxFormResolver(validate),
    defaultValues: { email: '', password: '' }
  });

  const handleFormSubmit = values => {
    const { email, password } = values;
    const { socket, signInUser: dispatchSignInUser } = props;

    // Simulate normalize trim
    return dispatchSignInUser({
      email: email?.trim(),
      password
    }, socket);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const { history } = props;

  return (
    <>
      <MainBg />
      <StyledMain>
        <CssBaseline />
        <DivPaper>
          <CompanyImgCnt>
            <CompanyImgLogo
              src={whitelabel.buildAssetUrl('media/logo.svg')}
              alt="logo"
            />
          </CompanyImgCnt>
          <StyledH5 component="h1" variant="h5">
            Sign in
          </StyledH5>
          <StyledForm
            onSubmit={handleSubmit(handleFormSubmit)}
            autoComplete="on"
          >
            <RHFTextField
              name="email"
              control={control}
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
            />
            <RHFTextField
              name="password"
              control={control}
              label="Password"
              variant="outlined"
              fullWidth
              margin="normal"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <ButtonsContainer>
              <Button
                disabled={isSubmitting}
                type="submit"
                variant="contained"
                color="secondary"
              >
                Sign in
              </Button>
              <ForgotBtn
                onClick={() => {
                  history.push('/forgotpassword');
                }}
              >
                Forgot password
              </ForgotBtn>
            </ButtonsContainer>
          </StyledForm>
        </DivPaper>
      </StyledMain>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    signInUser: (data, socket) => dispatch(signInUser(data, socket))
  };
}

SignInForm.propTypes = propTypes;

export default connect(null, mapDispatchToProps)(SignInForm);
